/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type PatientSummaryDtoContactTracingStatus =
  (typeof PatientSummaryDtoContactTracingStatus)[keyof typeof PatientSummaryDtoContactTracingStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatientSummaryDtoContactTracingStatus = {
  UNKNOWN: 'UNKNOWN',
  COMPLETED: 'COMPLETED',
  NOT_COMPLETED: 'NOT_COMPLETED',
} as const;
